var map = {
	"./common/en": [
		"78fo"
	],
	"./common/en.json": [
		"78fo"
	],
	"./common/zh-cn": [
		"1VKD"
	],
	"./common/zh-cn.json": [
		"1VKD"
	],
	"./en": [
		"p9le"
	],
	"./en.js": [
		"p9le"
	],
	"./i18n-language-list": [
		"kC5r",
		4
	],
	"./i18n-language-list.js": [
		"kC5r",
		4
	],
	"./i18n-setup": [
		"mAqB"
	],
	"./i18n-setup.js": [
		"mAqB"
	],
	"./zh-cn": [
		"jApH"
	],
	"./zh-cn.js": [
		"jApH"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Trjk";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/lang lazy ^\.\/.*$
// module id = Trjk
// module chunks = 65